// extracted by mini-css-extract-plugin
module.exports = {"layoutWrapper":"styles_layoutWrapper__oCz96"};